import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, useLocation, useRouteMatch, useHistory, Redirect } from 'react-router-dom'
import { usePermissions } from 'hooks/usePermissions'
import { FormattedMessage } from 'react-intl'
import { Tabs } from 'antd';
import Organizations from 'containers/Organizations'
import Users from 'containers/Users'
import Zones from 'containers/Zones'
import Groups from 'containers/Groups'
import NavigationHeader from 'components/NavigationHeader/NavigationHeader'
import {
  fetchOrganizations,
  fetchUsers,
  fetchZones,
  onOrganizationsPageUnmount,
  selectIsInitialized,
  setIsInitialized,
  fetchGroups,
  fetchVerticals,
} from 'store/global'
import messages from './messages'
import styles from './OrganizationsPage.scss'

export default function OrganizationsPage() {
  const dispatch = useDispatch()
  const permissions = usePermissions()
  const history = useHistory()

  const isAppInitialized = useSelector(selectIsInitialized)

  useEffect(() => {
    if (!isAppInitialized) return

    return () => {
      dispatch(onOrganizationsPageUnmount())
    }
  }, [isAppInitialized])

  useEffect(() => {
    if (!permissions.isInitialized) return

    dispatch(fetchUsers())
    dispatch(fetchVerticals())
    dispatch(fetchZones())
    dispatch(fetchOrganizations())
    dispatch(fetchGroups())

    dispatch(setIsInitialized(true))
  }, [permissions])

  const { pathname } = useLocation()
  const { path } = useRouteMatch()

  const allTabs = [
    {
      key: 'organizations',
      to: `${path}/organizations`,
      isDisplayed: true,
    },
    {
      key: 'groups',
      to: `${path}/groups`,
      isDisplayed: true,
    },
    {
      key: 'zones',
      to: `${path}/zones`,
      isDisplayed: true,
    },
    {
      key: 'users',
      to: `${path}/users`,
      isDisplayed: true,
    },
  ]

  const displayedTabs = allTabs.filter(({ isDisplayed }) => isDisplayed)

  const getCurrentActiveKey = () => {
    if (pathname === path) return 'organizations'
    const currentTab = displayedTabs.find(({ key }) => {
      const tabPath = `${path}/${key}`
      return pathname === tabPath
    })
    return currentTab ? currentTab.key : 'organizations'
  }

  const activeKey = getCurrentActiveKey()

  const handleTabChange = (key) => {
    const tab = displayedTabs.find(t => t.key === key)
    if (tab) {
      history.push(tab.to)
    }
  }

  const tabItems = displayedTabs.map(tab => ({
    key: tab.key,
    label: (
      <span className={styles.tabTitle}>
        <FormattedMessage {...messages.tabTitles[tab.key]} />
      </span>
    ),
  }))

  return (
    <main className={styles.container}>
      <nav id='navigationHeaderWrapper' className={styles.navigationHeaderWrapper}>
        <NavigationHeader />
      </nav>
      <div className={styles.content}>
        <Tabs
          activeKey={activeKey}
          onChange={handleTabChange}
          items={tabItems}
          type="line"
          size="large"
        />
        <Switch>
          <Route path={`${path}/users`} component={Users} />
          <Route path={`${path}/organizations`} component={Organizations} />
          <Route path={`${path}/zones`} component={Zones} />
          <Route path={`${path}/groups`} component={Groups} />
          <Route exact path={path} component={Organizations} />
        </Switch>
      </div>
    </main>
  )
}
